/**
 * Подготавливает данные формы редактирования заявки для API.
 * Не выполняет запросы и не меняет состояние формы.
 */
import { roundToTwoDecimals } from "@/utils/numberUtils";

/**
 * Нормализует числа и рейсы, исключает даты, управляемые точками маршрута.
 * Сохраняет смысл списка контрагентов: null/отсутствие — без изменений, [] — очистка.
 */
export function buildOrderUpdatePayload(formData) {
  const payload = {
    ...formData,
    price: roundToTwoDecimals(formData.price),
    cargo_weight: roundToTwoDecimals(formData.cargo_weight),
    cargo_volume: roundToTwoDecimals(formData.cargo_volume),
    min_temperature: roundToTwoDecimals(formData.min_temperature),
    max_temperature: roundToTwoDecimals(formData.max_temperature),
  };
  if (Array.isArray(formData.trip_ids)) {
    payload.trip_ids = formData.trip_ids.filter((id) => id);
  }
  delete payload.planned_pickup_at;
  delete payload.planned_delivery_at;

  return payload;
}
